import { render, staticRenderFns } from "./MergeFile.vue?vue&type=template&id=2bbbba6d&"
import script from "./MergeFile.vue?vue&type=script&lang=js&"
export * from "./MergeFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports